module.exports = __webpack_public_path__ + "img/pcb-side-key.prt.104c1c58.jpg";